"use strict";

exports.__esModule = true;
exports.makeValuePresentation = void 0;
var _wixDataSchemaTypes = require("@wix/wix-data-schema-types");
var _value = require("../../entities/value");
const makeValuePresentation = ({
  propConnection,
  fieldType,
  value
}, dependencies) => {
  const formattedValue = formatValue({
    propConnection,
    fieldType,
    value
  }, dependencies);
  const convertedValue = convertValueByOutputType({
    propConnection,
    fieldType,
    value: formattedValue
  }, dependencies);
  return convertedValue;
};

//TODO: Inline constant - issues with tree-shaking of wix-data-client-common
exports.makeValuePresentation = makeValuePresentation;
const DATETIME_FORMAT_TYPE = 'datetime';
const dateFieldTypes = [_wixDataSchemaTypes.FieldType.date, _wixDataSchemaTypes.FieldType.time, _wixDataSchemaTypes.FieldType.dateTime];
const formatValue = ({
  propConnection: {
    format: {
      type,
      params
    } = {}
  },
  fieldType,
  value
}, dependencies) => {
  if (type === DATETIME_FORMAT_TYPE && (dateFieldTypes.includes(fieldType) || _value.Value.isIsoString(value))) {
    return applyDateFormat({
      fieldType,
      value,
      dateFormat: params.dateFormat
    }, dependencies);
  }
  return applyDefaultFormat({
    fieldType,
    value
  });
};
const convertValueByOutputType = ({
  propConnection: {
    outputType
  },
  value,
  fieldType
}, dependencies) => {
  const convert = outputTypeToValueConverter[outputType] ?? outputTypeToValueConverter.default;
  return convert({
    fieldType,
    value
  }, dependencies);
};
const applyDateFormat = ({
  dateFormat,
  fieldType,
  value
}, {
  formatter
}) => {
  const dateTimeValue = fieldType === _wixDataSchemaTypes.FieldType.time ? `1970-01-01T${value}Z` : value;
  const date = new Date(dateTimeValue);
  if (isNaN(date.getTime()) || fieldType === _wixDataSchemaTypes.FieldType.dateTime && !_value.Value.isIsoString(value)) {
    return value;
  }
  const timeZone = fieldType === _wixDataSchemaTypes.FieldType.date || fieldType === _wixDataSchemaTypes.FieldType.time ? 'UTC' : undefined;
  return formatter.formatDateTime(date.toISOString(), dateFormat, {
    timeZone
  });
};
const applyDefaultFormat = ({
  fieldType,
  value
}) => value && (fieldType === _wixDataSchemaTypes.FieldType.dateTime || _value.Value.isIsoString(value)) ? new Date(value).toString() : value;
const outputTypeToValueConverter = {
  text: ({
    fieldType,
    value
  }) => {
    if (value === null || value === undefined) {
      return '';
    } else if (Array.isArray(value)) {
      return value.join(', ');
    } else if (fieldType === _wixDataSchemaTypes.FieldType.address) {
      return typeof value === 'object' && 'formatted' in value ? value.formatted : value;
    } else {
      return String(value);
    }
  },
  link: ({
    fieldType,
    value
  }, {
    mediaUtils
  }) => {
    if (value !== undefined && value !== null) {
      if (MEDIA_FIELD_TYPES.has(fieldType)) {
        try {
          return mediaUtils.convertToUrl(value);
        } catch {
          return value;
        }
      } else if (fieldType === _wixDataSchemaTypes.FieldType.email) {
        return `mailto:${value}`;
      }
    }
    return value;
  },
  default: ({
    value
  }) => value
};
const MEDIA_FIELD_TYPES = new Set([_wixDataSchemaTypes.FieldType.image, _wixDataSchemaTypes.FieldType.video, _wixDataSchemaTypes.FieldType.audio]);
//# sourceMappingURL=make-value-presentation.js.map